import { Link } from "react-router-dom";
import { useCart } from "../CartContext";
import { fmtEur } from "../api";

/** Floating cart summary shown bottom-right on buyer storefront pages
 *  (catalog + product detail). Auto-hides when the cart is empty.
 *  Never shown on the cart itself. */
export default function FloatingCartSummary() {
  const { cart, totalUnits } = useCart();
  if (totalUnits <= 0) return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-40 bg-[#1A1D1A] text-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-3 max-w-xs"
      data-testid="floating-cart"
    >
      <div>
        <div className="text-[11px] uppercase tracking-wider opacity-70">Cart</div>
        <div className="db-mono text-lg font-semibold" data-testid="floating-cart-subtotal">
          {fmtEur(cart?.subtotal || 0)}
        </div>
        <div className="text-[11px] opacity-70">
          {totalUnits} unit{totalUnits === 1 ? "" : "s"}
        </div>
      </div>
      <Link
        to="/cart"
        data-testid="floating-cart-review"
        className="bg-white text-[#1A1D1A] px-3 h-9 inline-flex items-center rounded-md text-sm font-medium hover:bg-[#E9F5EC] transition-colors"
      >
        Review →
      </Link>
    </div>
  );
}
